module.exports = __webpack_public_path__ + "img/snake.2c145d12.jpg";